// extracted by mini-css-extract-plugin
export default {"learnMoreLink":"YSpdLUP sY3mB1c london3-button"};